// extracted by mini-css-extract-plugin
module.exports = {"hover-only":"adEVN","hoverOnly":"adEVN","hover-only-and-collapsed":"TSp5L","hoverOnlyAndCollapsed":"TSp5L","hoverable":"_1Lz06"};